import { useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { usePresetTags } from '../../utils/use-preset-tags';

export const useTags = () => {
  const { customTags } = useSettings();
  const presetTags = usePresetTags();

  const flatPresetTags = useMemo(() => {
    return presetTags.flatMap((group) => group.items);
  }, [presetTags]);

  return useMemo(() => {
    return [...flatPresetTags, ...customTags];
  }, [flatPresetTags, customTags]);
};
